import styled, { keyframes } from 'styled-components';

const move = keyframes`
    0% {
        transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
        transform: translate(-50%, -50%) rotate(360deg);
    }
`;

const pulse = keyframes`
    0%, 100% {
        opacity: 0.3;
        transform: scale(1);
    }
    50% {
        opacity: 0.5;
        transform: scale(1.1);
    }
`;

export const BackgroundContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: -1;
    background: ${({ $PRIMARY_BG_COLOR }) =>
        $PRIMARY_BG_COLOR};
    overflow: hidden;
    pointer-events: none;
    transition: background 0.4s ease;
`;

export const Blob = styled.div`
    position: absolute;
    width: 800px;
    height: 800px;
    background: ${({ color }) => color};
    filter: blur(80px);
    border-radius: 50%;
    opacity: 0.4;
    will-change: transform;
    animation: ${move}
        ${({ duration }) => duration || '20s'} linear
        infinite;
    top: ${({ top }) => top || '50%'};
    left: ${({ left }) => left || '50%'};
`;

export const GradientOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(
        circle at 50% 50%,
        transparent 0%,
        ${({ $OVERLAY_COLOR }) => $OVERLAY_COLOR} 100%
    );
`;

export const MobileBackground = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
`;

export const MobileBlob = styled.div`
    position: absolute;
    width: 150%;
    height: 150%;
    top: -25%;
    left: -25%;
    background: ${({ $color }) => $color};
    filter: blur(60px);
    opacity: 0.4;
    animation: ${pulse} 10s ease-in-out infinite;
    will-change: transform, opacity;
`;
